/** How long after sign-up the game controls panel starts expanded. */
export const GAME_CONTROLS_EXPANDED_FOR_MS = 24 * 60 * 60 * 1000

/**
 * Whether the game controls panel starts expanded on the first room join: only during the
 * account's first 24 hours, when people are still learning the keys. A missing or unreadable
 * sign-up date (external guests have no Sevv account) counts as new, as before this rule.
 */
export function shouldExpandGameControls(
  createdAt: string | number | Date | null | undefined,
  now: number = Date.now()
): boolean {
  if (createdAt === null || createdAt === undefined || createdAt === '') return true
  const signedUpAt = new Date(createdAt).getTime()
  if (!Number.isFinite(signedUpAt)) return true
  return now - signedUpAt < GAME_CONTROLS_EXPANDED_FOR_MS
}
